import React, {Component} from 'react';
import { translate } from 'react-admin';
import {configAPI} from '../config'
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';

class ActiveCampaigns extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.timer = setInterval(()=> this.getItems(), 3000);
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }
    
    getItems() {
        const {push} = this.props;
        const ReqGetCampaigns = new Request(configAPI.api.prod+'GetActiveCampaigns?token='+sessionStorage.B.encodeDecode());
        fetch(ReqGetCampaigns)
            .then(response => { return response.json();})
            .then(Campaigns => {
                if (Campaigns.responseStatus==='OK') {
                    this.setState({activeCampaigns: Campaigns.campaigns.length});
                }
            else {
                push('/login');
                sessionStorage.clear();
            }
        })
    }

    render() {
        return <span>{this.state.activeCampaigns}</span>
    }

}
export default connect(null, {
    push: pushAction,
})(translate(ActiveCampaigns));